const RoleIcon2 = ({
  height = "24px",
  width = "24px",
  fillColor = "#183883",
}: {
  height?: string;
  width?: string;
  fillColor?: string;
}) => {
  return (
      <svg
        style={{ width: `${width}`, height: `${height}` }} // Use inline styles here
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.75 12.5V5C22.75 2.929 21.071 1.25 19 1.25C15.224 1.25 8.776 1.25 5 1.25C2.929 1.25 1.25 2.929 1.25 5V19C1.25 21.071 2.929 22.75 5 22.75H12.5C12.914 22.75 13.25 22.414 13.25 22C13.25 21.586 12.914 21.25 12.5 21.25H5C3.757 21.25 2.75 20.243 2.75 19V5C2.75 3.757 3.757 2.75 5 2.75H19C20.243 2.75 21.25 3.757 21.25 5V12.5C21.25 12.914 21.586 13.25 22 13.25C22.414 13.25 22.75 12.914 22.75 12.5Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22 6.25H2C1.586 6.25 1.25 6.586 1.25 7C1.25 7.414 1.586 7.75 2 7.75H22C22.414 7.75 22.75 7.414 22.75 7C22.75 6.586 22.414 6.25 22 6.25Z"
          fill={fillColor}
        />
        <path
          d="M12.75 5.25C13.1642 5.25 13.5 4.91421 13.5 4.5C13.5 4.08579 13.1642 3.75 12.75 3.75C12.3358 3.75 12 4.08579 12 4.5C12 4.91421 12.3358 5.25 12.75 5.25Z"
          fill={fillColor}
        />
        <path
          d="M15.5 5.25C15.9142 5.25 16.25 4.91421 16.25 4.5C16.25 4.08579 15.9142 3.75 15.5 3.75C15.0858 3.75 14.75 4.08579 14.75 4.5C14.75 4.91421 15.0858 5.25 15.5 5.25Z"
          fill={fillColor}
        />
        <path
          d="M18.25 5.25C18.6642 5.25 19 4.91421 19 4.5C19 4.08579 18.6642 3.75 18.25 3.75C17.8358 3.75 17.5 4.08579 17.5 4.5C17.5 4.91421 17.8358 5.25 18.25 5.25Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.2859 17.5352C21.2859 15.4652 19.6049 13.7852 17.5359 13.7852C15.4659 13.7852 13.7859 15.4652 13.7859 17.5352C13.7859 19.6042 15.4659 21.2852 17.5359 21.2852C19.6049 21.2852 21.2859 19.6042 21.2859 17.5352ZM19.7859 17.5352C19.7859 18.7762 18.7769 19.7852 17.5359 19.7852C16.2939 19.7852 15.2859 18.7762 15.2859 17.5352C15.2859 16.2932 16.2939 15.2852 17.5359 15.2852C18.7769 15.2852 19.7859 16.2932 19.7859 17.5352Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.071 18.2852H14.536C14.949 18.2852 15.286 17.9482 15.286 17.5352C15.286 17.1212 14.949 16.7852 14.536 16.7852H13.071C12.657 16.7852 12.321 17.1212 12.321 17.5352C12.321 17.9482 12.657 18.2852 13.071 18.2852Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9089 21.224L15.9449 20.188C16.2369 19.895 16.2369 19.42 15.9449 19.128C15.6519 18.835 15.1769 18.835 14.8839 19.128L13.8479 20.163C13.5559 20.456 13.5559 20.931 13.8479 21.224C14.1409 21.516 14.6159 21.516 14.9089 21.224Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.2859 21.9992V20.5352C18.2859 20.1212 17.9489 19.7852 17.5359 19.7852C17.1219 19.7852 16.7859 20.1212 16.7859 20.5352V21.9992C16.7859 22.4132 17.1219 22.7492 17.5359 22.7492C17.9489 22.7492 18.2859 22.4132 18.2859 21.9992Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.223 20.163L20.187 19.128C19.894 18.835 19.419 18.835 19.127 19.128C18.834 19.42 18.834 19.895 19.127 20.188L20.162 21.224C20.455 21.516 20.93 21.516 21.223 21.224C21.515 20.931 21.515 20.456 21.223 20.163Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.9999 16.7852H20.5359C20.1219 16.7852 19.7859 17.1212 19.7859 17.5352C19.7859 17.9482 20.1219 18.2852 20.5359 18.2852H21.9999C22.4139 18.2852 22.7499 17.9482 22.7499 17.5352C22.7499 17.1212 22.4139 16.7852 21.9999 16.7852Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.162 13.8479L19.127 14.8839C18.834 15.1769 18.834 15.6519 19.127 15.9449C19.419 16.2369 19.894 16.2369 20.187 15.9449L21.223 14.9089C21.515 14.6159 21.515 14.1409 21.223 13.8479C20.93 13.5559 20.455 13.5559 20.162 13.8479Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.7859 13.0703V14.5353C16.7859 14.9483 17.1219 15.2853 17.5359 15.2853C17.9489 15.2853 18.2859 14.9483 18.2859 14.5353V13.0703C18.2859 12.6563 17.9489 12.3203 17.5359 12.3203C17.1219 12.3203 16.7859 12.6563 16.7859 13.0703Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.8479 14.9089L14.8839 15.9449C15.1769 16.2369 15.6519 16.2369 15.9449 15.9449C16.2369 15.6519 16.2369 15.1769 15.9449 14.8839L14.9089 13.8479C14.6159 13.5559 14.1409 13.5559 13.8479 13.8479C13.5559 14.1409 13.5559 14.6159 13.8479 14.9089Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 10.75H14C14.414 10.75 14.75 10.414 14.75 10C14.75 9.586 14.414 9.25 14 9.25H5C4.586 9.25 4.25 9.586 4.25 10C4.25 10.414 4.586 10.75 5 10.75Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 13.75H11C11.414 13.75 11.75 13.414 11.75 13C11.75 12.586 11.414 12.25 11 12.25H5C4.586 12.25 4.25 12.586 4.25 13C4.25 13.414 4.586 13.75 5 13.75Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 16.75H9C9.414 16.75 9.75 16.414 9.75 16C9.75 15.586 9.414 15.25 9 15.25H5C4.586 15.25 4.25 15.586 4.25 16C4.25 16.414 4.586 16.75 5 16.75Z"
          fill={fillColor}
        />
      </svg>
  );
};
export default RoleIcon2;
